import { render, staticRenderFns } from "./ClaimReward.vue?vue&type=template&id=65d4ef5e&scoped=true&"
import script from "./ClaimReward.vue?vue&type=script&lang=js&"
export * from "./ClaimReward.vue?vue&type=script&lang=js&"
import style0 from "./ClaimReward.vue?vue&type=style&index=0&id=65d4ef5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d4ef5e",
  null
  
)

export default component.exports